var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserThumbnail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20m.02-18.46q-1.86 0-4.08.54-2.52.63-4.08 1.68Q10 24.99 10 26.52v2.52h20.04v-2.52q0-1.53-1.86-2.76-1.56-1.05-4.08-1.68-2.22-.54-4.08-.54m0-2.52q1.35 0 2.49-.675a5.1 5.1 0 0 0 1.815-1.815Q25 15.39 25 14.04t-.675-2.52a5 5 0 0 0-1.815-1.845A4.8 4.8 0 0 0 20.02 9q-1.35 0-2.49.675a5 5 0 0 0-1.815 1.845q-.675 1.17-.675 2.52t.675 2.49a5.1 5.1 0 0 0 1.815 1.815q1.14.675 2.49.675"
})));
export default SvgUserThumbnail;